<template>
  <div class="baniere pt-4 pb-20">
    <div class="box" />

    <div class="w-full pt-4">
      <div class="titre w-full mt-5">
        Solutions
      </div>
    </div>

    <div class="title1 mt-5 md:pr-10 pr-0">
      Nous avons une grande expérience dans les domaines dans lesquels nous sommes spécialisés, mais nous adorons embrasser l’inconnu et casser les codes.
    </div>

    <div class="md:flex mt-24">
      <div
        class="md:w-1/3 w-full md:mr-16 b"
        data-aos="flip-left"
        data-aos-duration="2000"
      >
        <svg-icon
          name="ic_bank"
          class="h-16 cursor-pointer"
          original
        />
        <div class="titre-item w-full mt-2">
          Banking
        </div>
        <div class="detail b">
          Nous améliorons le processus de montage, le traitement, l’octroi des prêts bancaires et facilitons le travail collaboratif en banque pour une expérience plus sobre à vos clients.
        </div>
        <div
          class="button mt-10 w-2/3"
          @click="goTo('banking')"
        >
          En savoir plus
        </div>
      </div>

      <div
        class="md:w-1/3 w-full md:mr-16 b md:mt-0 mt-20"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <svg-icon
          name="ic_insurance"
          class="h-16 cursor-pointer"
          original
        />
        <div class="titre-item w-full mt-2">
          Assurance
        </div>
        <div class="detail">
          Des solutions performantes pour répondre aux plus grands défis du secteur de l’assurance aujourd’hui, notamment la production, les sinistres, la lutte contre la fraude.
        </div>
        <div
          class="button mt-10 w-2/3"
          @click="goTo('assurance')"
        >
          En savoir plus
        </div>
      </div>

      <div
        class="md:w-1/3 w-full b md:mt-0 mt-20"
        data-aos="flip-left"
        data-aos-duration="2000"
      >
        <svg-icon
          name="ic_healthcare"
          class="h-16 cursor-pointer"
          original
        />
        <div class="titre-item w-full mt-2">
          Santé
        </div>
        <div class="detail">
          Nous mettons à  disposition une suite de solutions technologiques pour des soins sanitaires  personnalisés et pour améliorer la collaboration au sein des équipes de soins.
        </div>
        <div
          class="button mt-10 w-2/3"
          @click="goTo('sante')"
        >
          En savoir plus
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    goTo (index) {
      this.$router.push('/' + index)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $background-gray-dev;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .titre{
    font-weight: bold;
    font-size: 60px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $text-black-dev;
  }
  .title1{
    font-weight: 600;
    font-size: 32px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $black;
  }
  .titre-item{
    font-weight: 600;
    font-size: 32px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $text-black-dev;
  }
  .detail{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }
  .button{
    background-color: $background-gray-dev;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: $background-gray-dev;
    transition: all 1s ease-out;
  }
  .b:hover{
    .button{
      background-color: $dev-green;
      color: white;
    }
  }
  .box {
    background-image: url("../../../assets/images/png/courbe.png");
    position: absolute;
    width: 900px;
    height: 900px;
    right: -105px;
    top: 300px;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
  .b{
    position: relative;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 40px;
      line-height: 170%;
    }
    .title1{
      padding-right: 10px;
      font-size: 22px;
    }
    .titre-item{
      font-size: 26px;
    }
    .detail{
      font-size: 24px;
    }
    .button{
      background-color: $dev-green;
      height: 58px;
      font-size: 17.424px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 45px;
    }
    .title2{
      font-size: 28px;
    }
    .title1{
      font-size: 30px;
    }
    .detail{
      font-size: 20px;
    }
    .titre-item{
      font-size: 30px;
    }
    .button{
      background-color: $dev-green;
      height: 60px;
      font-size: 18px;
    }
  }

</style>
